import { Injector } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToasterService } from '../../services/toaster.service';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerService } from '../../services/spinner.service';
import { countryCode } from '../../models/countryCode.model';
import { AuthService } from '../../core/services/auth.service';
import Swal from 'sweetalert2';
import { CommonResponse } from '../../models/common.model';
import { responseStatus } from '../../core/constants/responseStatus.const';
import { environment } from '../../../environments/environment';

export class BaseClass {

  public route: ActivatedRoute;
  public authService: AuthService;
  public formBuilder: FormBuilder;
  public spinnerService: SpinnerService;
  public router: Router;
  public toasterService: ToasterService;
  public translateService: TranslateService;

  constructor (injector: Injector) {
    this.route = injector.get(ActivatedRoute);
    this.formBuilder = injector.get(FormBuilder);
    this.spinnerService = injector.get(SpinnerService);
    this.router = injector.get(Router);
    this.toasterService = injector.get(ToasterService);
    this.translateService = injector.get(TranslateService);
    this.authService = injector.get(AuthService);
  }

  // Returns the form data with the Phone Number , DialCode handling
  processPhoneNumber(
    formGroup: FormGroup,
    phoneFieldName: string,
    dialCodeFieldName: string,
    countryCodeObject: countryCode
  ): any {
    const value = { ...formGroup.value };
    const patchValueToCountryCode = (): void => {
      let tempCountryCode = formGroup.get(phoneFieldName)?.value || '';
      if (tempCountryCode) {
        tempCountryCode = tempCountryCode.split('');
        tempCountryCode.shift();
        tempCountryCode = tempCountryCode.join('');
      }
      if (tempCountryCode !== countryCodeObject.dialCode) {
        formGroup.patchValue({
          dialCodeFieldName: `+${countryCodeObject.dialCode}`
        });
        value[dialCodeFieldName] = `+${countryCodeObject.dialCode}`;
      }
    };
    const patchValueToPhoneField = (): void => {
      let phone = formGroup.get(phoneFieldName)?.value || '';
      if (phone && phone.includes(value[dialCodeFieldName])) {
        phone = phone.split(value[dialCodeFieldName])[1]?.trim() || '';
        value[phoneFieldName] = phone;
      }
    };
    patchValueToCountryCode();
    patchValueToPhoneField();
    return value;
  }
  
  mapCountryFlagToMatInput(phoneField: any, country_code: string | number): any {
    country_code =
        typeof country_code === 'number' ? country_code.toString() : country_code;
    let countryCode: string | string[] = country_code.split('');
    countryCode.shift();
    countryCode = countryCode.join('');
    const countryCodeObject = phoneField['allCountries'].find(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (el: any) => el['dialCode'] === countryCode
    );
  
    phoneField['selectedCountry'] = countryCodeObject;
    return {
      phoneField,
      countryCodeObject
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  logoutAlert(): Promise<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new Promise((resolve: any) => {
      Swal.fire({
        title: this.translateService.instant('AreYouSure'),
        text: this.translateService.instant('Youwillbeloggedout'),
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: this.translateService.instant('Cancel'),
        confirmButtonColor: '#043146',
        cancelButtonColor: '#000',
        confirmButtonText: this.translateService.instant('Logout')
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      }).then((result: any) => {
        return resolve(result);
      });
    });
  }
  
  logout(): void {
    this.logoutAlert().then((res: any) => {
      if (
        Object.prototype.hasOwnProperty.call(res, 'value') &&
          res.isConfirmed === true
      ) {
        this.spinnerService.addToLoader('logout');
        this.authService
          .logout()
          .subscribe({
            next: (res: CommonResponse) => {
              this.spinnerService.removeFromLoader('logout');
              if (res.statusCode === responseStatus.SUCCESS) {
                localStorage.removeItem(environment.storageKey);
                this.authService.profileDetails.next(null);
                this.toasterService.successToastr(
                  this.translateService.instant('LoggedOutSuccessfully')
                );
                this.router.navigate(['/']);
              }
            },
            error: () => {
              this.spinnerService.removeFromLoader('logout');
            }
          });
      }
    });
  }

}